import type {
  CannedWorkPackageStatus,
  CannedWorkTaskChargePublic,
  CannedWorkTaskDetailPublic,
  CannedWorkTaskVersionDetailPublic,
  TypeCertificateModelVariantWithParentPublic,
} from "@common/client"
import { variantLabel } from "@common/components/form/lookup/aircraft-type"
import { formatTotals } from "@/routes/_layout/quoting_/quotes/-lib/charge-math"

export function chargesPrice(charges: CannedWorkTaskChargePublic[]): string {
  return formatTotals(charges).filter(Boolean).join(" + ")
}

export function usableTasks(
  tasks: CannedWorkTaskDetailPublic[],
): CannedWorkTaskDetailPublic[] {
  return tasks.filter((task) => !task.deleted_at && task.approved_version)
}

export function applicabilityLabel(
  version: Pick<
    CannedWorkTaskVersionDetailPublic,
    "part" | "type_certificate_model_variants"
  >,
): string {
  if (version.part) return version.part.number
  const variants = version.type_certificate_model_variants
  if (variants.length === 0) return "Any aircraft"
  const [first, ...rest] = variants
  return rest.length === 0
    ? variantLabel(first)
    : `${variantLabel(first)} +${rest.length}`
}

export function quotePrice(tasks: CannedWorkTaskDetailPublic[]): string {
  return chargesPrice(
    usableTasks(tasks).flatMap((task) => task.approved_version?.charges ?? []),
  )
}

export function taskApplicabilityLabel(
  task: CannedWorkTaskDetailPublic,
): string {
  return task.template_quote_variants === null
    ? applicabilityLabel(task.latest_version)
    : quoteApplicabilityLabel(task.template_quote_variants)
}

export function quoteApplicabilityLabel(
  variants: TypeCertificateModelVariantWithParentPublic[],
): string {
  if (variants.length === 0) return "All models"
  const [first, ...rest] = variants
  return rest.length === 0
    ? variantLabel(first)
    : `${variantLabel(first)} +${rest.length}`
}

export function quoteStatus(
  tasks: CannedWorkTaskDetailPublic[],
): CannedWorkPackageStatus {
  const live = tasks.filter((task) => !task.deleted_at).length
  const approved = usableTasks(tasks).length
  if (approved === 0) return "draft"
  return approved === live ? "approved" : "in_progress"
}
